import { useTranslation } from "react-i18next";

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-20 mb-12">
          <div className="lg:w-3/5">
            <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              {t("why.title")}
            </h2>
          </div>
          <div className="lg:w-2/5">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {t("why.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-1 bg-background-100 rounded-2xl overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20colorful%20product%20database%20spreadsheet%20on%20clean%20white%20desk%20with%20fashion%20items%2C%20bright%20natural%20light%2C%20modern%20workspace%20aesthetic%2C%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20vibrant%20product%20colors&width=600&height=400&seq=kakobuy-why-db-v3&orientation=landscape"
                alt="Baza Produktów"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="text-lg font-bold text-foreground-900">{t("why.card1.title")}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t("why.card1.desc")}</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 flex flex-col justify-between">
            <div>
              <h3 className="text-lg font-bold text-foreground-900 text-center">{t("why.card2.title")}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t("why.card2.desc")}</p>
            </div>
            <div className="h-36 mt-4 overflow-hidden rounded-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Calendar%20and%20clock%20concept%20with%20refresh%20arrows%20on%20clean%20white%20surface%2C%20modern%20minimalist%20design%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20cool%20grey%20white%20tones%2C%20editorial%20style&width=500&height=300&seq=kakobuy-why-update-v3&orientation=landscape"
                alt="Aktualizacje"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 flex flex-col justify-between">
            <div>
              <h3 className="text-lg font-bold text-foreground-900 text-center">{t("why.card3.title")}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t("why.card3.desc")}</p>
            </div>
            <div className="h-36 mt-4 overflow-hidden rounded-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Digital%20shield%20and%20security%20checkmark%20concept%20on%20clean%20white%20surface%2C%20minimalist%20design%2C%20soft%20studio%20lighting%2C%20clean%20aesthetic%2C%20modern%20cybersecurity%20theme%2C%20cool%20grey%20tones%2C%20editorial%20style&width=500&height=300&seq=kakobuy-why-safety-v3&orientation=landscape"
                alt="Bezpieczeństwo"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}